var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.meta_loaded === true)?_c('router-view'):_vm._e(),(_vm.meta_loaded === false)?_c('div',{staticClass:"loading-wrapper"},[_c('loading')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }